import { render, staticRenderFns } from "./TruckStatusSelect.vue?vue&type=template&id=932dc564"
import script from "./TruckStatusSelect.vue?vue&type=script&lang=ts"
export * from "./TruckStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports